import React from 'react';
import Layout from '../components/Layout/Layout';

const AlumniRegistrationPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for registering! This is a demonstration. Your data has not been saved.');
  };

  return (
    <Layout>
      <div id="alumni-registration" className="page-container" style={{ maxWidth: '900px', margin: '40px auto', padding: '0 20px', minHeight: '500px' }}>
        
        <div style={{ backgroundColor: '#fff', padding: '40px 60px', borderRadius: '12px', border: '1px solid #eee', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
          <h2 style={{ color: '#004d99', borderBottom: '2px solid #0d6efd', paddingBottom: '15px', marginBottom: '30px', textAlign: 'center', fontSize: '2.5rem', fontWeight: 'bold' }}>
            Alumni Registration
          </h2>

          <p style={{ color: '#444', lineHeight: '1.6', marginBottom: '40px', fontSize: '1.05rem' }}>
            We are thrilled to reconnect with our cherished alumni! By registering with us, you become an official part of our growing alumni network, allowing you to stay connected with your alma mater and fellow graduates. Your registration helps us keep you informed about college news, events, and opportunities to engage.
          </p>

          <form onSubmit={handleSubmit} style={{ 
            backgroundColor: '#f8fbff', 
            borderLeft: '5px solid #0056b3', 
            padding: '40px', 
            borderRadius: '8px',
            boxShadow: 'inset 0 0 10px rgba(0,0,0,0.02)'
          }}>
            <h3 style={{ color: '#0056b3', fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '30px' }}>Register Here:</h3>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Full Name (as per college records):</label>
              <input type="text" required style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }} />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Email Address:</label>
              <input type="email" required style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }} />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Phone Number:</label>
              <input type="tel" required style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }} />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Course Studied:</label>
              <input type="text" placeholder="e.g., B.A. History, B.Com., B.Sc. Physics" required style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }} />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Year of Passing:</label>
              <input type="number" required style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }} />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Current Occupation/Profession:</label>
              <input type="text" required style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }} />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Current Company/Organization (Optional):</label>
              <input type="text" style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem' }} />
            </div>

            <div style={{ marginBottom: '35px' }}>
              <label style={{ display: 'block', color: '#0056b3', fontWeight: '600', marginBottom: '10px', fontSize: '1.1rem' }}>Message to the College (Optional):</label>
              <textarea rows="5" style={{ width: '100%', padding: '12px 15px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem', resize: 'vertical' }}></textarea>
            </div>

            <div style={{ textAlign: 'center' }}>
              <button type="submit" style={{ 
                backgroundColor: '#0056b3', 
                color: '#fff', 
                padding: '15px 40px', 
                border: 'none', 
                borderRadius: '8px', 
                fontSize: '1.2rem', 
                fontWeight: 'bold', 
                cursor: 'pointer',
                transition: 'background-color 0.3s ease'
              }}>
                Register Now
              </button>
            </div>
          </form>
        </div>

      </div>
    </Layout>
  );
};

export default AlumniRegistrationPage;
